import { useEffect, useState } from "react";

export default function useGithubProjects(username,isFeatured=false) {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchProjects() {
      try {
        setLoading(true);

        const response = await fetch(
          `https://api.github.com/users/${username}/repos?sort=updated&per_page=100`,{
            headers:{
              Accept:"application/vnd.github+json",
              Authorization : `Bearer ${process.env.REACT_APP_GITHUB_TOKEN}`,
              "X-GitHub-Api-Version":"2022-11-28"
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch GitHub repositories");
        }

        var data = await response.json();
        data = data.filter((repo)=> repo.topics?.includes("portfolio"))
        if(isFeatured){
          data = data.filter((repo)=>repo.topics?.includes("featured"))
        }
        setProjects(data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    }

    fetchProjects();
    
  }, [username,isFeatured]);

  return {
    projects,
    loading,
    error,
  };
}

